import { render } from "./P2PForm.vue?vue&type=template&id=2d3eca18&scoped=true"
import script from "./P2PForm.vue?vue&type=script&lang=js"
export * from "./P2PForm.vue?vue&type=script&lang=js"

import "./P2PForm.vue?vue&type=style&index=0&id=2d3eca18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3eca18"]])

export default __exports__